import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZKpiDefinition = z.object({
  kpiDefinitionId: z.string(),
  kpiName: z.string(),
  kpiDescription: z.string(),
  isCustomKpi: z.boolean(),
  isAssetLevel: z.boolean(),
  frequency: z.number(),
  isEnabled: z.boolean().nullable(),
  assetId: z.string().nullable().optional(),
  assetTypeId: z.string().nullable().optional()
})

const ZTiqKpiDefinitionDTO = z.object({
  totalCount: z.number(),
  content: z.array(ZKpiDefinition)
})
const ZTiqApiResponse = z.object({
  http_status: z.number(),
  data: ZTiqKpiDefinitionDTO.nullable(),
  error: z.boolean()
})

export type TiqKpiDefinitionDTO = z.infer<typeof ZTiqKpiDefinitionDTO>
export type KpiDefinitionData = z.infer<typeof ZKpiDefinition>

export async function getKpiList (
  pageNumber: number,
  pageSize: number,
  sortOrder: string,
  sortBy: string,
  filterValue: boolean,
  onSuccess: (KpiList: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = '/kpirest/api/v1/udp/tiq/kpi/allKpiSummary'

  interceptedAxios
    .get(url, {
      params: {
        pageNumber,
        pageSize,
        sortOrder,
        sortBy,
        filterValue
      },
      timeout: 25000
    })
    .then((response: any) => {
      const parseResponse = ZTiqApiResponse.safeParse(response.data)
      // istanbul ignore else
      if (parseResponse.success) {
        // istanbul ignore else
        if (
          parseResponse.data.data !== null &&
            parseResponse.data.data !== undefined
        ) {
          onSuccess(parseResponse.data.data, response.status)
        } else {
          onFailure(parseResponse.data.error, response.status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error: any) => {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      const statusCode = error.response ? error.response.status : 500
      onFailure(error.message, statusCode)
    })
}
